import '../styles/app.scss';

// 1. Import 3rd Party Libs
import './autoload/_bootstrap';
import './autoload/_fonts';
import fetchInject from 'fetch-inject';
window.fetchInject = fetchInject;

// 2. Import custom JS
import './util/current-breakpoint';
import './util/load-splide-async';
import './util/load-truncate-ellipsis-async';
import './util/element-is-in-viewport';
import './util/debounce';
import './util/load-bootstrap-multiselect-async';
import './util/load-richtext-async';
import './util/jq-initialize';
import './util/fr-helper';
import './util/urlUpdater';
import './util/truncate-text';
import './util/load-slick-async';
import './util/splide-resize-height-of-slider';

// 3. Import global JS
import './global/header';

// 4. Load components
import './components/embedded-video-thumbnail';
import './components/search-bar';
import './components/nav-search-button';
import './components/share-button';
import './components/like-button';
import './components/hero-shape-resize';
import './components/resource-modal';
import './components/locked-resource-modal';
import './components/open-modal';
import './components/submission-forms-modal';
import './components/bs-multiselect';
import './components/gravity-forms';
import './components/gravity-form-field-events';
import './components/custom-limit-js-initialize';
import './components/card-filter';
import './components/card';
import './components/salesforce-integration-form';

//5. Load blocks
import './blocks/home-hero';
import './blocks/case-highlight';
import './blocks/case-highlight-slider';
import './blocks/card-grid';
import './blocks/wysiwyg-card-slider';
import './blocks/topic-bar';
import './blocks/resource-card-grid';


//Make variables globals
window.currentBreakpoint = require('./util/current-breakpoint').currentBreakpoint;

( function( $ ) {
    window.customTinyMCEFunctions = function(editor) {
        $(editor.container).find('.mce-edit-area iframe').css('height', '');
    }
} )( jQuery );
